(function(angular) {
    angular.module('wtApp.wtSelector', [
        'wtApp.dataService',
        'ui.bootstrap.dropdown',
        'ui.bootstrap.typeahead',
        'ui.bootstrap.accordion',
        'ui.bootstrap.collapse',
        'ui.bootstrap.buttons',
        'pascalprecht.translate',
        'wtApp.wtCommon',
        'wtApp.KeyboardNavigation',
        'ngSanitize'
    ]).config(moduleConfig);
    moduleConfig.$inject = ['$translateProvider', '$translatePartialLoaderProvider'];
    function moduleConfig($translateProvider, $translatePartialLoaderProvider) {
        // define translation url template
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{part}/{lang}.json'
        });
        // Use $templateCache
        $translateProvider.useLoaderCache('$templateCache');
        // default language English
        $translateProvider.preferredLanguage('en');
        // Secure sanitize strategy
        $translateProvider.useSanitizeValueStrategy('escape');

        $translatePartialLoaderProvider.addPart('selector');
    }
})(window.angular);
